import DOMPurify from "dompurify";
import { marked } from "marked";

const isPlainText = (str) => !str.trim().startsWith("<") && !str.includes("</");

export function SafeHtml({ text }) {
  let cleaned = String(text).replace(/\(id:\s*[^)]+\)/gi, "");
  // if (isPlainText(cleaned)) {
  //   cleaned = cleaned.replace(/\n{2,}/g, "<br><br>").replace(/\n/g, "<br>");
  // }

  const rawHtml = marked.parse(cleaned || "");
  const cleanHtml = DOMPurify.sanitize(rawHtml);
  return <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
}
